module.exports = __webpack_public_path__ + "img/testscreenmodal.ec5c4d74.svg";